<template>
    <div :class="{'show': openSuggestion }" v-on-clickaway="away" class="btn-group multi-select">
        <button v-on:click.prevent="toggleOpen" class="btn btn-default" :class="triggerClass" v-html="displaySelected"></button>
        <button v-on:click.prevent="toggleOpen" class="btn btn-trigger" :class="triggerClass"><i class="fa fa-caret-down"></i></button>
        <ul class="dropdown-menu">
            <li v-show="hasEmpty" v-on:click="suggestionClick(null)">{{ placeholder || ' - ' }}</li>
            <li v-for="suggestion, i in list" v-on:click="suggestionClick(suggestion)" v-html="display(suggestion)"></li>
        </ul>
    </div>
</template>

<script type="text/babel">
    import { mixin as clickaway } from 'vue-clickaway';

    export default{
        data(){
            return{
                open: false,
                current: 0,
                suggestions: [],
            }
        },
        computed:{
            //The flag
            openSuggestion () {
                console.log(this.open);
                return this.open === true;
            },
            displaySelected(){
                var _this = this;
                if(!_this.value) return this.placeholder ||  ' - ';

                if(_this.id && _this.label && this.value){
                    var s = _this.list.filter( l => { return l[_this.id] == _this.value });
                    if(!s.length) this.placeholder ||  ' - ';
                    return s[0][_this.label];
                }
                return _this.value;
            }
        },
        filters:{},
        methods: {


            display(value){
                if(typeof value == 'object' && this.label){
                    return value[this.label];
                }
                return value || " - "

            },
            toggleOpen (){
                console.log(this.list);
                this.open = !this.open;
                //this.setValue();
            },

            //When the user changes input
            change() {
                if (this.open == false) {
                    this.open = true;
                    this.current = 0;
                }
            },
            //When one of the suggestion is clicked
            suggestionClick(suggestion) {
                if(!suggestion){
                    this.$emit('input',null);
                } else if(typeof suggestion == 'object' && this.id && this.label){
                    this.$emit('input', suggestion[this.id]);
                } else {
                    this.$emit('input', suggestion);
                }
                this.away();
                this.$emit('blur');

            },
            setValue(){
            },
            away: function() {
                this.open = false;
            }

        },
        mixins: [ clickaway ],
        mounted (){},
        props: {
            list: {
                type: Array,
                required: false
            },
            value: {
                type: String,
                required: false
            },
            default:{
                type: String,
                required: false
            },
            placeholder: {
                type: String,
                required: false,
                default: ''
            },
            multi: {
                type: Boolean,
                required: false
            },
            hasEmpty: {
                type: Boolean,
                required: false,
                default: false
            },
            triggerClass:{
                type: String,
                required: false
            },
            id:{
                type: String,
                required: false
            },
            label:{
                type: String,
                required: false
            }
        },

    }
</script>
<style>
    .dropdown-menu li{
        padding: 5px 10px;
        border-bottom: 1px solid #e2e2e2;
        cursor: pointer;
    }

    .show>.dropdown-menu {
        display: block;
    }
    .dropdown-menu li:hover{
        background-color: #f5f5f5;
    }
    ul.dropdown-menu {
        max-height: 250px;
        overflow-y: scroll;
    }
    .dropdown-menu {
        padding: 0;
    }
</style>



// WEBPACK FOOTER //
// Dropdown.vue?c4f33b80